module.exports = __webpack_public_path__ + "img/venus-mars.6e87624f.svg";